import { useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useSpeechContext } from "../../Services/Context/SpeechContext";
import { useLanguage } from "../../Services/Context/LanguageContext";
import "./FloatingSpeechButton.css";

interface FloatingSpeechButtonProps {
  active: boolean;
}

const FloatingSpeechButton = ({ active }: FloatingSpeechButtonProps) => {
  const { toggle, enabled, isSupported } = useSpeechContext();
  const { translate } = useLanguage();

  // Stop speech when leaving reading phase
  useEffect(() => {
    if (!active) window.speechSynthesis?.cancel();
  }, [active]);

  if (!isSupported) return null;

  return (
    <AnimatePresence>
      {active && (
        <motion.button
          className={`FloatingSpeech${enabled ? "" : " FloatingSpeech--muted"}`}
          onClick={toggle}
          initial={{ opacity: 0, scale: 0.8, y: 10 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.8, y: 10 }}
          transition={{ duration: 0.3, ease: [0.16, 1, 0.3, 1] }}
          whileHover={{ scale: 1.06 }}
          whileTap={{ scale: 0.94 }}
          aria-label={enabled ? "Mute reading" : "Unmute reading"}
        >
          {enabled ? translate("soundOn") : translate("soundOff")}
        </motion.button>
      )}
    </AnimatePresence>
  );
};

export default FloatingSpeechButton;
